import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Settings, Home } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

const AdminNavLink: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAdminStatus();
  }, [user]);

  const checkAdminStatus = async () => {
    setIsLoading(true);
    try {
      if (!user) {
        setIsLoading(false);
        return;
      }
      
      // Check if user has admin role directly from the user object
      if (user.isAdmin) {
        console.log("User is admin according to user object");
        setIsLoading(false);
        return;
      }
      
      // If we're already on the admin route, allow access
      // This prevents unnecessary database queries when already in admin mode
      if (isAdminRoute) {
        setIsLoading(false);
        return;
      }
      
      // Don't show the button on the landing page
      if (location.pathname === '/' || location.pathname === '/index.html') {
        setIsLoading(false);
        return;
      }
    } catch (error) {
      console.error('Error checking admin status:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Only show admin button if:
  // 1. User is logged in AND is an admin
  // 2. Not on public pages (landing, auth, how-it-works, about-us, privacy, terms, support)
  const publicPaths = ['/', '/index.html', '/auth', '/how-it-works', '/about-us', '/privacy', '/terms', '/support'];
  const isPublicPath = publicPaths.some(path => location.pathname === path);

  if (isLoading || !user || !user.isAdmin || isPublicPath) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      <button
        onClick={() => navigate(isAdminRoute ? '/dashboard' : '/admin')}
        className="flex items-center gap-2 px-3 py-2 bg-white shadow-md rounded-lg hover:bg-slate-50 transition-colors text-sm"
      >
        {isAdminRoute ? (
          <>
            <Home className="w-4 h-4 text-teal-600" />
            <span>Main App</span>
          </>
        ) : (
          <>
            <Settings className="w-4 h-4 text-slate-600" />
            <span>Admin Panel</span>
          </>
        )}
      </button>
    </div>
  );
};

export default AdminNavLink;